module.exports = __webpack_public_path__ + "img/ic_google.400b8604.svg";